import { useParams } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { getComicsByCategory } from '@/mocks/comics';
import { categories } from '@/mocks/categories';
import { siteConfig } from '@/mocks/siteConfig';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const comics = getComicsByCategory(slug || 'romance');

  return (
    <Layout>
      <div className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: currentCategory.name },
          ]}
        />

        {/* Category Header */}
        <section className="bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-500">
                <i className={`${currentCategory.icon} text-2xl text-background-50`}></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
                  {currentCategory.name}漫画
                </h1>
                <p className="text-sm text-foreground-500 mt-1">{currentCategory.description}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="border-b border-background-200/70 bg-background-50 sticky top-16 z-40">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-1 overflow-x-auto py-3">
              {categories.map((cat) => (
                <a
                  key={cat.slug}
                  href={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* Comic Grid */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-10">
          {comics.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
              {comics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500 text-sm">该分类暂无漫画，请浏览其他分类</p>
              <a href="/" className="inline-block mt-4 text-primary-500 hover:text-primary-600 text-sm font-medium">
                返回首页
              </a>
            </div>
          )}
        </section>

        {/* Category SEO Content */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 pb-10">
          <div className="bg-background-100 rounded-xl p-6">
            <h2 className="text-lg font-bold font-heading text-foreground-950 mb-3">
              关于{currentCategory.name}韩国漫画
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed">
              韩漫画网为您精选多部优质{currentCategory.name}韩国漫画资源。{currentCategory.description}。
              我们提供下拉式免费阅读体验，让您尽情享受{currentCategory.name}韩漫的精彩内容。
              每日更新，完全免费，是您韩漫在线观看的最佳选择。
            </p>
          </div>
        </section>
      </div>
    </Layout>
  );
}